// removed by extract-text-webpack-plugin
module.exports = {"top":"Recovery__top___2muAd","title":"Recovery__title___2AB4p","searchBar":"Recovery__searchBar___eFzOw","search":"Recovery__search___2j_aR"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Recovery/components/Recovery.scss
// module id = 1222
// module chunks = 1